import React, { useState, useEffect } from 'react';
import { Terminal } from 'lucide-react';

const LiveFeedTerminal = () => {
  // Helper to generate random log data
  const generateLog = (offsetSeconds = 0) => {
    const queries = ['auto_insurance', 'saas_crm', 'health_supp', 'mortgage_refi', 'ev_pricing', 'cloud_hosting'];
    const statuses = ['MATCH', 'MATCH', 'MATCH', 'PENDING', 'FILTERED'];
    
    const now = new Date();
    // Adjust time if we are pre-filling history
    if (offsetSeconds > 0) {
        now.setSeconds(now.getSeconds() - offsetSeconds);
    }
    
    const timeString = now.toLocaleTimeString('en-US', { hour12: false });
    const randomQuery = queries[Math.floor(Math.random() * queries.length)];
    const randomBid = '$' + (Math.random() * 15 + 2).toFixed(2);
    const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];

    return {
      id: Date.now() - (offsetSeconds * 1000), // Unique ID based on time
      time: timeString,
      query: `category:${randomQuery}`,
      bid: randomBid,
      status: randomStatus
    };
  };

  // Initialize state with 5 pre-existing logs
  const [logs, setLogs] = useState(() => {
    const initialLogs = [];
    for (let i = 0; i < 5; i++) {
        initialLogs.push(generateLog(i * 1.5)); 
    }
    return initialLogs;
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const newLog = generateLog(0); // Generate log for "now"
      setLogs(prevLogs => [newLog, ...prevLogs].slice(0, 6)); // Keep 6 items max
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full md:w-1/2 relative group">
      {/* Background Glow */}
      <div className="absolute -inset-4 bg-gradient-to-tr from-blue-100 to-purple-100 rounded-3xl blur-2xl opacity-60"></div>
      
      {/* Main Terminal Container - Increased height for larger font */}
      <div className="relative bg-slate-900 text-white border border-slate-800 rounded-3xl shadow-2xl p-8 font-mono text-sm h-[380px] flex flex-col">
        
        {/* 1. Header (Fixed at top) */}
        <div className="flex-none flex items-center justify-between mb-4 border-b border-slate-700 pb-4">
            <div className="flex items-center gap-2">
                <div className="h-3 w-3 rounded-full bg-green-500 animate-pulse"></div>
                <span className="font-bold text-green-500 tracking-wider">LIVE_INTENT_STREAM</span>
            </div>
            <Terminal className="h-5 w-5 text-slate-500" />
        </div>
        
        {/* 2. Logs Area */}
        <div className="flex-1 overflow-hidden relative">
            <div className="space-y-4 absolute w-full top-0 left-0"> 
                {logs.map((log) => (
                  <div key={log.id} className="flex items-center gap-4 border-b border-slate-800/50 pb-2 last:border-0 animate-in fade-in slide-in-from-top-2 duration-500">
                    <span className="text-slate-500 w-20">{log.time}</span>
                    <span className="text-blue-400 flex-1 truncate">{log.query}</span>
                    <span className="text-purple-400 w-16 text-right hidden sm:block">{log.bid}</span>
                    <span className={`w-20 text-right font-bold ${
                      log.status === 'MATCH' ? 'text-green-500' : 
                      log.status === 'FILTERED' ? 'text-red-500' : 'text-yellow-500'
                    }`}>{log.status}</span>
                  </div>
                ))}
            </div>
        </div>

        {/* 3. Footer (Fixed at bottom) */}
        <div className="flex-none mt-auto pt-4 border-t border-slate-800/60 flex items-center gap-2">
             <span className="h-2 w-2 bg-green-500 rounded-full animate-ping"></span>
             <span className="text-green-500 tracking-wide">_ Processing signals...</span>
        </div>

      </div>
    </div>
  );
};

export default LiveFeedTerminal;